import React, { useEffect, useRef } from "react";

import { Button } from "antd";
import Modal from "antd/es/modal/Modal";
// eslint-disable-next-line import/no-extraneous-dependencies
import Lottie from "lottie-react";
import moment from "moment";

import SuccessAnimationData from "../../../../../assets/images/common/animation/SuccessAnimation.json";
import "./NewSampleRetestSuccessModal.css";

export default function NewSampleRetestSuccessModal({
  submissionDate,
  onDone,
  heading = "Retest Request created for",
}) {
  const lottieRef = useRef(null);

  const playSuccessAnimation = () => {
    if (lottieRef.current) {
      lottieRef.current.goToAndPlay(0, true);
    }
  };

  useEffect(() => {
    const timer = window.setTimeout(playSuccessAnimation, 200);
    return () => window.clearTimeout(timer);
  }, []);

  const formattedDate = submissionDate
    ? moment(submissionDate).format("Do MMMM, YYYY")
    : "";

  return (
    <Modal
      open
      maskClosable={false}
      closable={false}
      centered
      footer={null}
      afterOpenChange={(isOpen) => {
        if (isOpen) playSuccessAnimation();
      }}
      wrapClassName="NewSampleRetestSuccessModal"
      className="NewSampleRetestSuccessModal"
      width="591px"
    >
      <div className="NewSampleRetestSuccessModal__Content">
        <div className="NewSampleRetestSuccessModal__Animation" aria-hidden>
          <Lottie
            lottieRef={lottieRef}
            animationData={SuccessAnimationData}
            loop={false}
            autoplay={false}
          />
        </div>

        <p className="NewSampleRetestSuccessModal__Heading">
          {heading}
          <br />
          <span className="NewSampleRetestSuccessModal__Date">{formattedDate}</span>
        </p>

        <Button
          type="primary"
          className="NewSampleRetestSuccessModal__DoneBtn"
          onClick={onDone}
        >
          Done
        </Button>
      </div>
    </Modal>
  );
}
